import './index.scss';

export default {
    name: 'chj-radio',
    props: {
        value: null,
        inputType: {
            type: String,
            default: 'input'
        },
        rows: {
            type: Number,
            default: 3
        },
        placeholder: {
            type: String,
            default: ''
        },
        title: {
            type: String,
            default: ''
        },
        tips: {
            type: String,
            default: ''
        },
        required: Boolean,
        errorTips: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            isChecked: false
        };
    },
    mounted() {},
    methods: {
        choiceRadio(isChecked) {
            this.isChecked = isChecked;
            this.$emit('radioResult', isChecked);
        }
    }
};
